import React, { useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import styles from './styles/ScenarioCarousels.module.css';
import ScenarioCarousel from './ScenarioCarousel'; 
import LeftSideBar from "./LeftSideBar";
import MobileCategories from "./MobileCategories";
import BottomNav from "./BottomNav";
import EducationViewAll from './EducationViewAll';



const ScenarioCarousels = ({ variant = "default" }) => {
    const [activeTab, setActiveTab] = useState("Featured");
    const [activeSubTab, setActiveSubTab] = useState('');
    const [showEducationViewAll, setShowEducationViewAll] = useState(false);
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);

    const handleTagClick = (tag) => {
        setActiveTab('');
        setActiveSubTab('');
        navigate(`/browse/${encodeURIComponent(tag)}`);
    };

    const mapSubTabToTag = (subTabName) =>
        subTabName.toLowerCase().replace(/\s+/g, '-');

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isEducation = activeTab === "Education";

    return (
    <div className={styles.container}>
      {/* Desktop sidebar */}
      {!isMobile && (
          <LeftSideBar
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              activeSubTab={activeSubTab}
              setActiveSubTab={setActiveSubTab}
              popularTags={["sat", "english", "math"]}
              onTagClick={handleTagClick}
          />
      )}

      {/* Mobile categories replacing desktop sidebar */}
      {isMobile && (
        <MobileCategories
          variant={variant}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          activeSubTab={activeSubTab}
          setActiveSubTab={setActiveSubTab}
          onTagClick={handleTagClick}
        />
      )}

      {/* Scenario cards */}
      <main className={styles.rightPanel}>
                <div className={styles.heading}>
                    <div className={styles.sectionTitle}>
                        {activeSubTab || activeTab}
                    </div>
                    {isEducation && (
                        <button
                            className={styles.viewAll}
                            onClick={() => setShowEducationViewAll(true)}
                        >
                            View all categories in education
                        </button>
                    )}
                </div>

                <ScenarioCarousel
                    activeTab={activeTab}
                    activeSubTab={activeSubTab}
                    mapSubTabToTag={mapSubTabToTag}
                />
            </main>

            {/* Education View All Modal */}
            {showEducationViewAll && (
                <EducationViewAll
                    onClose={() => setShowEducationViewAll(false)}
                    onSelectTag={(tag) => {
                        setActiveSubTab(tag);
                        setShowEducationViewAll(false);
                    }}
                />
            )}

            {isMobile && <BottomNav />}
        </div>
    );
};


export default ScenarioCarousels;






